import { render, staticRenderFns } from "./TranslateModule.vue?vue&type=template&id=5d88561a&scoped=true"
import script from "./TranslateModule.vue?vue&type=script&lang=js"
export * from "./TranslateModule.vue?vue&type=script&lang=js"
import style0 from "./TranslateModule.vue?vue&type=style&index=0&id=5d88561a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d88561a",
  null
  
)

export default component.exports